<template>
  <BaseListV2
    :model-class="Group"
    :collection-filter="filter"
    :help-message="'A group defines a set of users. Groups are used to grant permissions to users.'"
  />
</template>

<script setup lang="ts">
import { useStore } from 'vuex'

import BaseListV2 from '@/components/common/BaseListV2.vue'
import { Group } from '@/models/core/models'
const store = useStore()
const filter = {
  organisation: store.getters['global/organisation'].id,
  order_by: 'name',
}
</script>
